import { Component, Input, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WorkflowStepItemModel } from "./models/workflow-step-item";
import { WorkflowStepStatus } from "./models/workflow-step-status.enum";
import { CerrixHoverCardDirective } from "../cerrix-hover-card/cerrix-hover-card.directve";

@Component({
    selector: "cerrix-workflow-bar",
    templateUrl: "./cerrix-workflow-bar.component.html",
    styleUrls: ["./cerrix-workflow-bar.component.scss"],
    imports: [CommonModule, CerrixHoverCardDirective],
    encapsulation: ViewEncapsulation.None,
})
export class CerrixWorkflowBarComponent {
    @Input() public steps: WorkflowStepItemModel[];

    protected readonly WorkflowStepStatus: typeof WorkflowStepStatus = WorkflowStepStatus;

    protected getLeftSeparatorWorkflowStatus(index: number): WorkflowStepStatus {
        if (index === 0) {
            return WorkflowStepStatus.Active;
        }

        const currentStepStatus = this.steps[index].status;
        const previousStepStatus = this.steps[index - 1].status;

        if (
            [WorkflowStepStatus.Rejected, WorkflowStepStatus.Disabled].includes(currentStepStatus)
        ) {
            return currentStepStatus;
        }

        if (previousStepStatus === WorkflowStepStatus.Active) {
            return WorkflowStepStatus.Disabled;
        }
        return WorkflowStepStatus.Completed;
    }
}
